import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center pt-20 pb-16">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            {/* Carletto Image */}
            <img
              src="/carletto/9.png"
              alt="Carletto confuso"
              className="w-64 h-auto mx-auto mb-8"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h1 className="text-8xl font-display font-bold text-primary mb-4">404</h1>
            <h2 className="heading-md mb-4">Oops! Pagina non trovata</h2>
            <p className="text-xl text-dark-500 mb-8">
              Carletto ha cercato ovunque, ma questa pagina sembra essere scomparsa!
              Forse è stata spostata o non esiste più.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/" className="btn-primary">
                <Home className="w-5 h-5" />
                Torna alla Home
              </Link>
              <button
                onClick={() => window.history.back()}
                className="btn-outline"
              >
                <ArrowLeft className="w-5 h-5" />
                Torna Indietro
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 p-6 bg-primary/10 rounded-2xl"
          >
            <p className="text-dark-600">
              Stavi cercando di confrontare le tariffe?{' '}
              <a
                href="https://compare.bollettaamica.com/home/energia"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-semibold hover:underline"
              >
                Vai al comparatore
              </a>
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  )
}
